import React from 'react';
import { useLanguage } from '../../../../hooks/useLanguage';
import { appData } from '../../../../data/portfolioData';
import './Hero.css';
import HeroImage from '../../assets/hero.jpg';

const Hero = () => {
  const { getText } = useLanguage();

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              {getText('portfolio.hero.profession').toUpperCase()}
            </h1>
            <p className="hero-subtitle">
              Angular | Spring Boot | Laravel | React | React Native | ASP.NET | Next.js | Gatsby.js | Django | Drupal
            </p>
            <p className="hero-description">
              {getText('portfolio.hero.description')}
            </p>
            <div className="hero-buttons">
              <button className="btn btn-primary" onClick={scrollToContact}>
                {getText('portfolio.hero.contactButton').toUpperCase()}
              </button>
              <a 
                href={appData.personal.whatsapp} 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-outline"
              >
                WhatsApp
              </a>
            </div>
          </div>
          <div className="hero-image">
            <img src={HeroImage} alt={`${appData.personal.name} - ${getText('portfolio.hero.profession')}`} />
            <div className="hero-image-overlay"></div>
          </div>
        </div>
      </div>
      <div className="hero-background">
        <div className="hero-shape"></div>
        <div className="hero-shape-2"></div>
      </div>
    </section>
  );
};

export default Hero;
